__webpack_require__.p = "/agenda/";